var _excluded = ["property"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { getImageUrl, AllImageSizes } from '@domain-group/fe-allhomes-library/lib/enums/image-size';
import NewDevelopmentChildDetails from './new-development-child-details';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment NewDevelopmentChildDetails on Property {\n    listing {\n      id\n    }\n    development {\n      name\n      url\n      summary\n      website\n      coverImage\n      thumbnail\n      children {\n        listing {\n          id\n          url\n          firstImage {\n            imageSrc\n          }\n          price\n          title\n        }\n        features {\n          propertyType\n          bedrooms\n          bathrooms {\n            bathrooms\n            ensuites\n          }\n          parking {\n            garages\n            carports\n            other\n          }\n        }\n      }\n      developer {\n        logo\n        logoBackgroundColour\n      }\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _development$develope, _development$develope2;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listing = _ref.listing,
    listing = _ref$listing === void 0 ? {} : _ref$listing,
    _ref$development = _ref.development,
    development = _ref$development === void 0 ? {} : _ref$development;
  return {
    name: development.name,
    thumbnail: getImageUrl(development.coverImage || development.thumbnail, AllImageSizes.LARGE),
    summary: development.summary,
    newDevelopmentUrl: development.url,
    newDevelopmentWebsite: development.website,
    otherListings: development.children.filter(child => child.listing.id !== listing.id).map(_ref2 => {
      var childListing = _ref2.listing,
        features = _ref2.features;
      return {
        id: childListing.id,
        url: childListing.url,
        title: childListing.title,
        images: {
          listingImage: childListing.firstImage && getImageUrl(childListing.firstImage.imageSrc, AllImageSizes.PHONE_LARGE),
          listingImageLowResolution: childListing.firstImage && getImageUrl(childListing.firstImage.imageSrc, AllImageSizes.SMALL)
        },
        price: childListing.price,
        features: {
          beds: features.bedrooms,
          baths: features.bathrooms.bathrooms,
          ensuite: features.bathrooms.ensuites,
          garage: features.parking.garages,
          carport: features.parking.carports,
          parking: features.parking.other,
          propertyType: features.propertyType
        }
      };
    }),
    logo: (_development$develope = development.developer) === null || _development$develope === void 0 ? void 0 : _development$develope.logo,
    logoBackgroundColour: (_development$develope2 = development.developer) === null || _development$develope2 === void 0 ? void 0 : _development$develope2.logoBackgroundColour
  };
};
var NewDevelopmentChildDetailsGraphQL = _ref3 => {
  var property = _ref3.property,
    props = _objectWithoutProperties(_ref3, _excluded);
  return ___EmotionJSX(NewDevelopmentChildDetails, _extends({}, graphQLToProps(property), props));
};
NewDevelopmentChildDetailsGraphQL.fragment = fragment;
NewDevelopmentChildDetailsGraphQL.propTypes = {
  property: PropTypes.shape({
    development: PropTypes.shape({})
  })
};
NewDevelopmentChildDetailsGraphQL.defaultProps = {
  property: {}
};
export default NewDevelopmentChildDetailsGraphQL;